import { setAuthCookie } from "@/lib/authCookies";
import type { AxiosInstance } from "axios";

export interface CompanyAssociation {
  company_user_id: number;
  company_id: number;
  company_name: string;
  role_id: number;
  role_name: string;
}

export const isTruthyFlag = (value: unknown) =>
  value === true || value === "true" || value === 1 || value === "1";

export async function fetchCompanyAssociations(
  apiClient: AxiosInstance,
  params: {
    p_ca_user_id: unknown;
    p_company_id: unknown;
    p_logged_in_company_user_id: unknown;
  },
): Promise<CompanyAssociation[]> {
  const response = await apiClient.get(
    "/v1/company_user/company_association_by_user",
    { params },
  );

  return (response.data || [])
    .map((item: CompanyAssociation) => ({
      company_user_id: item.company_user_id,
      company_id: item.company_id,
      company_name: item.company_name,
      role_id: item.role_id,
      role_name: item.role_name,
    }))
    .sort((a: CompanyAssociation, b: CompanyAssociation) =>
      a.company_name.localeCompare(b.company_name),
    );
}

export function applyCompanySelection(company: CompanyAssociation) {
  setAuthCookie("company_id", company.company_id);
  setAuthCookie("company_name", company.company_name);
  setAuthCookie("company_user_id", company.company_user_id);
  setAuthCookie("user_role", company.role_name);
  setAuthCookie("user_role_id", company.role_id);
}
